<template>
    <div class="casino-games__grid">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: 'GamesGrid',
    };
</script>



// WEBPACK FOOTER //
// src/app/modules/games/shared/components/GamesGrid.vue